import { type PBIDemoReport } from 'managed-analytics/domain/PBIReport'

export const SHIPPER_GUIDE_LIBRARY_CATEGORY = 'ShipperGuide – Freight'
export const OPENDOCK_LIBRARY_CATEGORY = 'Opendock – Dock & Yard'
export const OTHER_LIBRARY_CATEGORY = 'Other'

// Maps the backend `category` key to the section heading shown on the page.
const LABEL_BY_CATEGORY: Record<string, string> = {
  shipperguide: SHIPPER_GUIDE_LIBRARY_CATEGORY,
  opendock: OPENDOCK_LIBRARY_CATEGORY,
}

// Section order. Anything not listed (including untagged reports, which land in
// "Other") sorts after these, alphabetically.
const CATEGORY_ORDER = [
  SHIPPER_GUIDE_LIBRARY_CATEGORY,
  OPENDOCK_LIBRARY_CATEGORY,
  OTHER_LIBRARY_CATEGORY,
]

export function demoLibraryCategory(report: PBIDemoReport): string {
  return LABEL_BY_CATEGORY[report.category] ?? OTHER_LIBRARY_CATEGORY
}

export function groupDemoReportsByCategory(
  reports: Array<PBIDemoReport>
): Array<[string, Array<PBIDemoReport>]> {
  const grouped = reports.reduce(
    (acc, report) => {
      const category = demoLibraryCategory(report)
      acc[category] = [...(acc[category] || []), report]
      return acc
    },
    {} as Record<string, Array<PBIDemoReport>>
  )

  return Object.entries(grouped).sort(([left], [right]) => {
    const leftIndex = CATEGORY_ORDER.indexOf(left)
    const rightIndex = CATEGORY_ORDER.indexOf(right)

    if (leftIndex === -1 && rightIndex === -1) {
      return left.localeCompare(right)
    }
    if (leftIndex === -1) return 1
    if (rightIndex === -1) return -1
    return leftIndex - rightIndex
  })
}
